import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';
@Component({
  selector: 'app-waterpressure',
  templateUrl: './waterpressure.component.html',
  styleUrls: ['./waterpressure.component.scss']
})
export class WaterpressureComponent implements OnInit {

  constructor(
  	private navBar:NavBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService
  	) { }
  getWaterPressure():string{
  	return "1.2";
  }
  scaleValue(){
  	return 1.2/3.6;
  }
  handler(evt){
  	switch(evt){
  		case 'menu':{
  			this.menuService.goto('contactInfo');
        console.log("Going to contactInfo.");
        return;
  		}
	  	case 'back':{
	  		this.navBar.disableAll();
	  		this.menuService.goto('dashboard');
        return;
	  	}
	  	default:{
	  		return;
	  	}
  	}
  }
  subscription:any=undefined;
  ngOnDestroy(){
  	if(this.subscription){
  		this.subscription.unsubscribe();
  	}
  }
  ngOnInit() {
  	console.log("Initializing Waterpressure.");
    this.menuService.disableButton('up');
    this.menuService.disableButton('down');
  	this.navBar.enableAll();
  	this.navBar.blink('pressure');
  	this.subscription = this.ioService.inputs.events$.subscribe(
      (evt)=>{
  		  this.handler(evt);
  	  }
    );
  }
}

